module.exports = __webpack_public_path__ + "img/grey.058f7a81.png";